/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function GroupsExceptionModalController (this: JS5Object, PERMISSION_EXCEPTION_LIST: JS5Object, GroupsService: JS5Object) {
    this.exception = {};

    this.closeHandler = () => {
        let exceptionPermission = this.resolve.exceptionPermission;
        exceptionPermission.exception = this.exception;

        this.close({
            $value: {
                exceptionPermission: exceptionPermission,
                isEdit: this.resolve.isEdit
            }
        });
    };

    this.$onInit = () => {
        const stateName = GroupsService.XJS.xml2js(this.resolve.exceptionPermission.permission.permissionContext.targetCriteria).and.condition._property;
        this.includeOffset = _.get(_.get(PERMISSION_EXCEPTION_LIST, stateName), 'includeOffset');

        if (this.resolve.isEdit) {
            this.contentType = this.resolve.exceptionPermission.exception.content.type;
            this.exception = this.resolve.exceptionPermission.exception;
        } else {
            this.contentType = 'Series';
        }
    };
}

angular.module('prism-ui.groups').component('groupsExceptionModal', {
    templateUrl: 'system/groups/modals/groups-exception-modal-template.html',
    controller: GroupsExceptionModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});
